import React, { useMemo } from 'react';
import { Button } from '@material-ui/core';
import { GetApp } from '@material-ui/icons';
import styles from './Copy.module.scss';

const DownloadComponent = ({ transcription }) => {
  const downloadTranscriptAsTxt = () => {
    const blob = new Blob(
      [
        transcription
          .map(
            (t) =>
              `${t.role === 'coach' ? 'AI Prospect' : t.role} - ${t.name} [${t.timestamp}]\n${
                t.content
              }`
          )
          .join('\n\n'),
      ],
      { type: 'text/plain' }
    );
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = 'transcription.txt';
    link.click();

    URL.revokeObjectURL(url);
  };
  const isDisabled = useMemo(() => {
    if (!transcription || transcription?.length === 0) return true;
    return false;
  }, [transcription]);
  return (
    <div className={styles.button}>
      <Button
        startIcon={<GetApp fontSize="small" />}
        onClick={downloadTranscriptAsTxt}
        disabled={isDisabled}
      >
        Download
      </Button>
    </div>
  );
};
export default DownloadComponent;
